import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import NoIndex from "../utils/NoIndex";

export default function ProtectedRoute({ children }) {
  // "checking" | "authenticated" | "unauthenticated" — a raw string in
  // localStorage proves nothing by itself (anyone can type one into dev
  // tools), so access is only granted once the backend has actually
  // confirmed the stored token is real and still valid.
  const [authStatus, setAuthStatus] = useState("checking");

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    if (!token) {
      setAuthStatus("unauthenticated");
      return;
    }

    let cancelled = false;

    axiosInstance
      .get("api/user")
      .then(() => {
        if (!cancelled) setAuthStatus("authenticated");
      })
      .catch(() => {
        // Covers both a missing/expired/revoked token and a network
        // failure — either way, the dashboard isn't shown, and a stale
        // token isn't left behind for a future check to trip over.
        localStorage.removeItem("authToken");
        if (!cancelled) setAuthStatus("unauthenticated");
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (authStatus === "checking") {
    return (
      <>
        <NoIndex title="Admin | 360 SynergyTech" />
        <div style={{ textAlign: "center", padding: "80px 0" }}>
          Checking authentication...
        </div>
      </>
    );
  }

  if (authStatus === "unauthenticated") {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <NoIndex title="Admin | 360 SynergyTech" />
      {children}
    </>
  );
}
